import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import {
    useForm,
    useFetch,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useGrid,
    useModal,
    useResource,
    usePage,
} from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_TRMNL_OPTR_CD_SRCH, SCHEMA_GRID_TRMNL_OPTR_CD } from "./services/ComnCdService";
import { Link } from "react-router-dom";
export const TerminalOperatorCodeList = (props: any) => {
    const pgeUid = "trmnlOptrCdList";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const params = props.params;

    const form = {
        trmnlOptrCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_TRMNL_OPTR_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        trmnlOptrCdList: useGrid({
            defaultSchema: SCHEMA_GRID_TRMNL_OPTR_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getTrmnlOptrCdLst: useFetch({
            api: (page = grid.trmnlOptrCdList.page) => {
                return APIS.getTrmnlOptrCdLst(form.trmnlOptrCdSrch.getValues(), page, grid.trmnlOptrCdList.size);
            },
            enabled: comnUtils.isEmpty(form.trmnlOptrCdSrch.errors) && form.trmnlOptrCdSrch.isSubmitted,
            key: [grid.trmnlOptrCdList.page, grid.trmnlOptrCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.trmnlOptrCdSrch.getValues(),
                    page: grid.trmnlOptrCdList.page,
                    size: grid.trmnlOptrCdList.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.trmnlOptrCdSrch.handleSubmit(
                () => {
                    grid.trmnlOptrCdList.setPage(0);
                    fetch.getTrmnlOptrCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.trmnlOptrCdList.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_TrmnlOptrCdLst: {
            cell: {
                trmnlOptrCd: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.trmnlOptrNm, data: rowValues });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        // if (params?.wrhsOprtTpCd) {
        //     console.log(params.wrhsOprtTpCd);
        //     form.trmnlOptrCdSrch.setValue("wrhsOprtTpCd", params.wrhsOprtTpCd);
        // }
        // if (params?.cstmOfceCd) {
        //     console.log(params.cstmOfceCd);
        //     form.trmnlOptrCdSrch.setValue("cstmOfceCd", params.cstmOfceCd);
        // }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.trmnlOptrCdList.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_TRMNL_OPTR_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.trmnlOptrCdSrch.schema.trmnlOptrCd}></Group.Control>
                                <Group.Control {...form.trmnlOptrCdSrch.schema.trmnlOptrNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    onClick={() => {
                                        form.trmnlOptrCdSrch.reset();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid
                        {...grid.trmnlOptrCdList.grid}
                        data={fetch.getTrmnlOptrCdLst.data?.trmnOptrList}
                        render={render.grid_TrmnlOptrCdLst}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
